import moment from 'moment';

const fixedLength = (str: string | number, len: number = 2) => {
  str = String(str);
  while (str.length < len) {
    str = `0${str}`;
  }

  return str;
};

export const createElement = (tag: string, option: any) => {
  let dom = document.createElement(tag);

  Object.keys(option || {}).forEach((key: string) => {
    // @ts-ignore
    dom[key] = option[key];
  });

  return dom;
};

const checkBufferLength = (buffered: Array<any>) => {
  let len = buffered.length;
  if (len) {
    // @ts-ignore
    let end = buffered.end(len - 1);
    return end;
  }
  return 0;
};

export const formatVideoTime = (time: number) => {
  let duration = moment.duration(time);
  let hours = duration.hours();
  let minutes = duration.minutes();
  let seconds = duration.seconds();

  if (hours || minutes || seconds) {
    if (hours) {
      return `${fixedLength(hours)}:${fixedLength(minutes)}:${fixedLength(
        seconds
      )}`;
    } else {
      return `${fixedLength(minutes)}:${fixedLength(seconds)}`;
    }
  } else {
    return '--:--';
  }
};

const PluginCustomProgress = window.Aliplayer
  ? window.Aliplayer.Component({
      init: function(start: number, duration: number) {
        this.el = null;
        this.player = null;
        this.start = start;
        this.duration = duration;
        this.bindTimeUpdate = this.timeUpdate.bind(this);

        this.bindTouchStart = this.touchStart.bind(this);
        this.bindTouchMove = this.touchMove.bind(this);
        this.bindTouchEnd = this.touchEnd.bind(this);

        this.bindMouseDown = this.mouseDown.bind(this);
        this.bindMouseMove = this.mouseMove.bind(this);
        this.bindMouseUp = this.mouseUp.bind(this);

        this.bindCanPlay = this.videpCanPlay.bind(this);

        this.progressBar = null;
        this.timeBar = null;

        this.videoEl = null;

        this.timeUpdateDuration = false;
        if (duration === -1) {
          this.timeUpdateDuration = true;
        }
      },
      createEl: function(el: any, player: any) {
        this.el = el;
        this.videoEl = this.el.querySelector('video');
        this.player = player;
        this.player.on('timeupdate', this.bindTimeUpdate);

        try {
          this.el.querySelector('.prism-progress').style.display = 'none';
        } catch (e) {}
        try {
          if (this.duration > 0) {
            this.el.querySelector('.prism-time-display').style.display = 'none';
          }
        } catch (e) {}

        this.progressBar = document.createElement('div');
        this.timeBar = document.createElement('div');

        // 进度条设置
        this.progressBar.className = 'player-progress';
        this.progressLoaded = createElement('div', {
          className: 'player-progress-loaded'
        });
        this.progressBar.appendChild(this.progressLoaded);

        this.progressPlayed = createElement('div', {
          className: 'player-progress-played'
        });
        this.progressBar.appendChild(this.progressPlayed);
        this.el
          .querySelector('.prism-controlbar')
          .appendChild(this.progressBar);

        // 进度条需要绑定一下事件
        // 判断一下是否支持触屏事件
        // @ts-ignore
        if (typeof window.document.ontouchend != 'undefined') {
          this.progressBar.addEventListener('touchstart', this.bindTouchStart);
        } else {
          this.progressBar.addEventListener('mousedown', this.bindMouseDown);
        }

        // 时间条
        this.timeBar.className = 'player-timebar';
        this.timeBar.innerText = `00:00`;

        if (this.duration > 0) {
          this.el.querySelector('.prism-controlbar').appendChild(this.timeBar);
        }
      },

      mouseDown: function(e: MouseEvent) {
        this.el.addEventListener('mouseup', this.bindMouseUp);
        this.el.addEventListener('mousemove', this.bindMouseMove);

        clearTimeout(this.touch_timer);
        this.touch_timer = setTimeout(this.bindMouseUp, 1000);
      },
      mouseMove: function(e: MouseEvent) {
        clearTimeout(this.touch_timer);
        this.touch_timer = setTimeout(this.bindMouseUp, 1000);
      },
      mouseUp: function(e: MouseEvent) {
        clearTimeout(this.touch_timer);
        this.el.removeEventListener('mouseup', this.bindMouseUp);
        this.el.removeEventListener('mousemove', this.bindMouseMove);
        if (e) {
          let { offsetX, target } = e;
          let touchEnd = offsetX;
          // @ts-ignore
          let { clientWidth } = target;
          let percent = touchEnd / clientWidth;
          console.log(Math.round(percent * this.duration + this.start));
          this.player.seek(Math.round(percent * this.duration + this.start));
        }
      },

      touchStart: function(e: TouchEvent) {
        this.el.addEventListener('touchend', this.bindTouchEnd);
        this.el.addEventListener('touchmove', this.bindTouchMove);

        clearTimeout(this.touch_timer);
        this.touch_timer = setTimeout(this.bindTouchEnd, 1000);
      },
      touchMove: function(e: any) {
        clearTimeout(this.touch_timer);
        this.touch_timer = setTimeout(this.bindTouchEnd, 1000);
      },
      touchEnd: function(e: TouchEvent) {
        clearTimeout(this.touch_timer);
        this.el.removeEventListener('touchend', this.bindTouchEnd);
        this.el.removeEventListener('touchmove', this.bindTouchMove);

        if (e) {
          let { touches, target, changedTouches } = e;
          let touch = null;
          if (touches && touches.length) {
            touch = touches[0];
          } else if (changedTouches && changedTouches.length) {
            touch = changedTouches[0];
          }

          if (touch && target) {
            let touchEnd = touch.clientX;
            let { clientWidth } = target;
            let percent = touchEnd / clientWidth;
            console.log(Math.round(percent * this.duration + this.start));
            this.player.seek(Math.round(percent * this.duration + this.start));
          }
        }
      },
      play: function(player: any) {
        let playerDuration = this.player.getDuration();

        if (!Number.isNaN(playerDuration)) {
          this.duration = playerDuration;
        }
        let current = this.player.getCurrentTime();
        if (current < this.start) {
          this.player.on('canplay', this.bindCanPlay);
        }
      },
      videpCanPlay: function() {
        let current = this.player.getCurrentTime();
        if (current < this.start) {
          this.player.seek(Number(this.start));
        }
      },
      timeUpdate: function() {
        if (this.timeUpdateDuration) {
          this.duration = this.player.getDuration();
        }
        let current = this.player.getCurrentTime();
        if (current > this.start) {
          let right = current - this.start;
          let playPercent = right / this.duration;

          this.timeBar.innerText = `${formatVideoTime(
            right * 1000
          )} / ${formatVideoTime(this.duration * 1000)}`;
          this.progressPlayed.style.width = `${playPercent * 100}%`;
        }

        let bufferEnd = checkBufferLength(this.videoEl.buffered);
        if (bufferEnd > this.start) {
          let bufferPercent = (bufferEnd - this.start) / this.duration;
          this.progressLoaded.style.width = `${bufferPercent * 100}%`;
        }

        if (current > this.start + this.duration) {
          this.player.seek(this.start);
        }
      }
    })
  : null;

export default PluginCustomProgress;
